import React, {useEffect, useState, useRef} from 'react'
import { buyers } from '../Options'
import { useParams, useNavigate } from 'react-router-dom'
import Sidebar from '../Sidebar'
export default function EditLintCotton() {
  //states
  const [date, setDate] = useState()
  const [dateformat, setDateFormat] = useState('')
  const [province_id, setProvinceID] = useState()
  const [province, setProvince] = useState()
  const [district_id, setDistrictID] = useState()
  const [district, setDistrict] = useState()
  const [station_id, setStationID]= useState()
  const [station, setStation] = useState()
  const [seller, setSeller] = useState()
  const [buyer, setBuyer] = useState()
  const [quality_type, setquality_type]= useState()
  const [deal_type, setdeal_type] = useState()
  const [rates, setRates]= useState()
  const [clbs, setClbs]  = useState()
  const [bales, setBales] = useState()
  //stations
  const [options, setOptions] = useState([])
  
  //for dollar rate and clbs
  const [x, setX] = useState()
  const [dollarRate, setDollarRate] = useState()
  const [rateAvl, setRateAvl] = useState(false)

  //Submit object
  const [lintObject, setLintObject] = useState({
    bales:"",
    buyer:"",
    "c/lbs":"",
    date:"",
    deal_type:"",
    district:"",
    district_id:"",
    province:"",
    province_id:"",
    quality_type:"",
    rates:"",
    seller:"",
    station:"",
    station_id:""
  })

  //Navigation on submit 
  const navigate = useNavigate();

  //references
  const statRef = useRef(null)
  const sellRef = useRef(null)
  const buyRef = useRef(null)
  const qualRef = useRef(null)
  const dealRef = useRef(null)
  const rateRef = useRef(null)
  const clbsRef = useRef(null)
  const baleRef = useRef(null)

 


  //station changer
  const ferrit = async() =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/getLookup`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()
    setOptions(data)
  }

  useEffect(()=>{
    ferrit()
  },[])


  useEffect(()=>{
    gerrit2(date)
  }, [date])

  //station handler
  const stationHandler = (event) => {
    const selectedName = event.target.value;
    const selectedOption = options.find(option => option.name === selectedName);
    setStation(selectedName);
    setStationID(String(selectedOption.value));
    setProvince(selectedOption.province);
    setProvinceID(Number(selectedOption.province_id));
    setDistrictID(String(selectedOption.district_id));
  };


  //seller handler
  const sellerHandler = (e) =>{
    setSeller(e.target.value)
  }

  //buyer handler
  const buyerHandler = (e) =>{
    setBuyer(e.target.value)
  }

  //quality type handler
  const quality_typeHandler =(e)=>{
    setquality_type(e.target.value)
  }

  //deal type
  const deal_typeHandler = (e)=>{
    setdeal_type(e.target.value)
  }


  //rates
  const ratesHandler =(e)=>{
    const inputValue = e.target.value
    const numericValue = parseFloat(inputValue)
    setRates(numericValue)
    const clbsValue = (numericValue / x).toFixed(2);
    setClbs(clbsValue);
  }


  //clbs
  const clbsHandler =(e) =>{
    setClbs(e.target.value)
  }



  //bales
  const balesHandler = (e)=>{
    setBales(e.target.value)
  }


 
//date formatting fixture
function formatDateToYYYYMMDD(inputDate) {
const dateObject = new Date(inputDate);
const year = dateObject.getFullYear();
const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
const day = String(dateObject.getDate()).padStart(2, '0');

return `${year}-${month}-${day}`;
}

const {_id} = useParams()
  const gerrit = async () =>{
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`,{
      headers: {
        'x-access-token': token
      }
    })
    const data = await response.json()

    setDate(data.date.split('T')[0])
    setStation(data.station)
    setSeller(data.seller)
    setBuyer(data.buyer)
    setProvince(data.province)
    setProvinceID(data.province_id)
    setDistrictID(data.district_id)
    setStationID(data.station_id)
    setdeal_type(data.deal_type)
    setquality_type(data.quality_type)
    setClbs(data["c/lbs"])
    //Let this be
    setRates(data.minimum)
    setBales(data.bales)
    setDateFormat(formatDateToYYYYMMDD(data.date))
  }

  useEffect(()=>{
    gerrit()
  },[])

  //fetching the USD rate
  const gerrit2 = async (date)=>{
    const token = sessionStorage.getItem('token')
    const url = `${process.env.REACT_APP_API_URL}/usd-rate-ch?dates=${date}`
    const response = await fetch(url, {
      method:"GET",
      headers:{
        "Content-Type":"application/json",
        'x-access-token':token
      }
    })
    if(!response.ok){
      setRateAvl(false)
    }
    else{
      const data = await response.json()
      setDollarRate(data.buying)
      setRateAvl(true)
    }
  }

  useEffect(()=>{
    setX((dollarRate*82.28456)/100)
  }, [dollarRate])


  //submit
  const handleSubmit = async(e) =>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
    const variables = [date, station, seller, buyer, deal_type, quality_type, rates, clbs, bales]
    if (variables.every((variable) => variable === "")) {
      alert("No field is filled!");
      return; 
    }
    
    if (variables.every((variable) => typeof variable === 'undefined')) {
        return alert('No field should be empty');
    } 
  
    if(date  === null || station  === null || seller  === null || buyer  === null || quality_type  === null || deal_type === null || rates  === null || bales  === null || clbs  === null){
      return// console.log("No field is supposed to be empty")
    }
    const lint = {date, station, station_id, district, district_id, province, province_id, seller, buyer, quality_type, deal_type, minimum:rates, maximum:rates, bales, "c/lbs":clbs}

    await fetch(`${process.env.REACT_APP_API_URL}/admin/prices/${_id}`,{
      method: "PUT",
      headers: {
        "Content-Type":"application/json",
        'x-access-token':token
      },
      body: JSON.stringify(lint)
    }).then(
      navigate("/lintcotton")
    )
  }

  return (
<>  <div className="sidebar">
    <Sidebar/>
  </div>
    <div id='bydrop'>
      
<form onSubmit={handleSubmit} className='needs-validation'>
    <div className="row">
        <div className="col-md-6">
            {/**Date */}
            <label htmlFor="num-value" className="form-label">Date</label>
            {/* <div className="input-group input-group-md mb-3">
                <input type="date" id="num-value" value={String(dateformat)} className="form-control" aria-label="Small"   onChange={(e) => {
                  setDate(e.target.value)
                  setDateFormat(formatDateToYYYYMMDD(e.target.value))
                }} aria-describedby="inputGroup-sizing-sm" />
            </div> */}
            <div className="input-group input-group-md mb-3">
                <input type="date" id="num-value" value={date} required className="form-control" aria-label="Small"   onChange={(e) => {
                  setDate(e.target.value)
                }} aria-describedby="inputGroup-sizing-sm" />
            </div>
        </div>
        <div className="col-md-6">
            {/**Station */}
            <label htmlFor="inputGroupSelect07" className="form-label">Station</label>
            <div className="input-group mb-3">
                <select className="form-select" id="inputGroupSelect07"  onChange={(e) => stationHandler(e)}  ref={statRef}   aria-label="Select example">
                    <option value="">{station}</option>
                    {options.map((option) => (
                        <option key={option.value} value={option.name}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    </div>

    <div className="row">
        <div className="col-md-6">
            {/**Seller */}
            <label htmlFor="sellerInput" className="form-label">Seller</label>
            <div className="input-group input-group-md mb-3">
                <input type="text" id="sellerInput" value={seller} required className="form-control" aria-label="Small" onChange={sellerHandler} ref={sellRef}   aria-describedby="inputGroup-sizing-sm"></input>
            </div>
        </div>
        <div className="col-md-6">
            {/**Buyer */}
            <label htmlFor="inputGroupSelectBuyer" className="form-label">Buyer</label>
            <div className="input-group mb-3">
                <select className="form-select" id="inputGroupSelectBuyer" value={buyer} onChange={buyerHandler}   ref={buyRef} aria-label="Select example">
                    {/* <option value="">{buyer}</option> */}
                    {buyers.map((buyer) => (
                        <option key={buyer.value} value={buyer.name}>
                            {buyer.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    </div>

    <div className="row">
        <div className="col-md-6">
            {/**Quality Type*/}
            <label for="exampleFormControlTextarea1" class="form-label" >Quality Type</label>
      <div className="input-group mb-3">
        <select className="form-select" id="inputGroupSelect07" value={quality_type} onChange={quality_typeHandler}  ref={qualRef} aria-label="Select example">
          
          <option value="1">Normal</option>
          <option value="2">Low</option>
          <option value="3">Good</option>
        </select>
      </div>
        </div>
        <div className="col-md-6">
            {/**Deal Type */}
            <label for="exampleFormControlTextarea1" class="form-label" >Deal Type</label>
      <div className="input-group mb-3" >
        <select className="form-select" required id="inputGroupSelect07" value={deal_type} onChange={deal_typeHandler}  ref={dealRef} aria-label="Select example">
          {/* <option value="">{deal_type}</option> */}
          <option value="1">Normal</option>
          <option value="2">Conditional</option>
        </select>
      </div>
        </div>
    </div>

    {
      rateAvl && <div className="row">
      <div className="col-md-6">
          {/**Rates*/}
          <label for="exampleFormControlTextarea1" class="form-label" >Rates</label>
      <div class="input-group input-group-md mb-3">
          <input type="number" class="form-control" required value={rates}aria-label="Small"onChange={ratesHandler} ref={rateRef} min="0"  aria-describedby="inputGroup-sizing-sm"/>
      </div>
      </div>
      <div className="col-md-6">
          {/**Clbs */}
          <label for="exampleFormControlTextarea1" class="form-label" >C/lbs</label>
      <div class="input-group input-group-md mb-3">
          <input type="number" 
          class="form-control" 
          step="0.000000000000000001"
          value={clbs} 
          aria-label="Small" 
          onChange={clbsHandler} 
          ref={clbsRef}
          min="0" 
          disabled  
          required  
          aria-describedby="inputGroup-sizing-sm"/>
      </div>
      </div>
  </div>
    }

    {!rateAvl && 
          <div class="alert alert-danger d-flex align-items-center" role="alert">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
</svg> <div>        
                      No USD rate found for the given date. Make sure rate is uploaded to be able to submit the form
          </div>
          </div>
          }

          
          {!rateAvl && 
          <div className="row">
              <div className="col-md-6">
                  {/**Rates*/}
                  <label for="exampleFormControlTextarea1" class="form-label" >Rates</label>
              <div class="input-group input-group-md mb-3">
                  <input disabled type="number" step="any"class="form-control" aria-label="Small" min="0"required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
              <div className="col-md-6">
                  {/**Clbs */}
                  <label for="exampleFormControlTextarea1" class="form-label" >Clbs</label>
              <div class="input-group input-group-md mb-3">
                  <input disabled type="number" class="form-control" aria-label="Small" step="0.000000000000000001" min="0" required aria-describedby="inputGroup-sizing-sm"/>
              </div>
              </div>
          </div>}

    <div className="row">
        <div className="col-md-6">
            {/**Bales*/}
            <label for="exampleFormControlTextarea1" class="form-label" >Bales</label>
        <div class="input-group input-group-md mb-3">
            <input type="number" class="form-control" value={bales}aria-label="Small" onChange={balesHandler} ref={baleRef} min="0"   aria-describedby="inputGroup-sizing-sm"/>
        </div>
        </div>
    </div>

    <button type="submit"  className="btn btn-secondary btn-lg">Update</button>
</form>

    </div></>
  
  )
}
